<template>
  <div>
    <div v-if="scope.row.status === 1">
      <el-button type="text" @click="downLoadFiles(scope.row)">
        下载
      </el-button>
      <el-button type="text" @click="del(scope.row)">删除</el-button>
    </div>
    <div v-else>
      <div v-if="status">
        <el-tooltip content="设备不在线，请先上线设备后再试" placement="top" effect="light" v-if="deviceStatus !== 0 ">
          <el-button  type="text" :class="deviceStatus !== 0? 'stop':''">同步</el-button>
        </el-tooltip>
        <el-button v-else type="text" @click="syncHandler(scope.row)">同步</el-button>
      </div>
      <el-progress v-else :percentage="percentage" :color="customColorMethod"></el-progress>
    </div>
  </div>
</template>
<script>
import { syncFile, querySyncInfo, queryUploadProgress, downloadFile, deleteFile } from '@/api/fileServer'
import { loadFileByUrl } from '@/utils'
export default {
  props: {
    scope: {
      type: Object
    },
    productKey: {
      type: String
    },
    deviceName: {
      type: String || null
    },
    deviceStatus: {
      type: Number
    }
  },
  data () {
    return {
      percentage: 0,
      status: true,
      timer: '',
      times: 0,
      timed: 0
    }
  },
  created () {
  },
  methods: {
    customColorMethod (percentage) {
      if (percentage < 30) {
        return '#909399'
      } else if (percentage < 70) {
        return '#e6a23c'
      } else {
        return '#67c23a'
      }
    },
    // 点击同步功能
    syncHandler (row) {
      this.status = false
      console.log(row)
      const params = {
        productKey: this.productKey,
        deviceName: this.deviceName,
        fileName: row.fileName,
        fileType: row.fileType
      }
      syncFile(params).then((res) => {
        console.log(res.status)
        if (res.status === 200) {
          if (res.data.code === 200) {
            this.timer = setInterval(() => {
              this.queryInfo(params)
            }, 1000)
          }
        } else {
          this.$message({
            type: 'error',
            message: '同步出错，请重试'
          })
          this.status = true
        }
      }).catch((error) => {
        if (error.response.status !== 200) {
          this.$message({
            type: 'error',
            message: '请求失败,请稍后再试'
          })
          setTimeout(() => {
            this.status = true
          }, 500)
        }
      })
    },
    queryInfo (params) {
      querySyncInfo(params).then((res) => {
        this.times++
        console.log('时间', this.times)
        // 若超过10s并且有数据返回
        if (this.times > 10) {
          clearInterval(this.timer)
          this.$message({
            type: 'warning',
            message: '同步文件超时,请稍后再试'
          })
          this.$emit('getServerfileList')
          this.status = true
          this.times = 0
          return false
        } else {
          if (JSON.stringify(res.data.data) !== 'null') {
            clearInterval(this.timer)
            this.times = 0
            if (res.data.data.md5) {
              this.timer = setInterval(() => {
                this.UploadProgress(params)
              }, 1000)
            } else {
              this.$message({
                type: 'warning',
                message: '设备中不存在该文件'
              })
              this.status = true
              this.$emit('getServerfileList')
              return false
            }
            this.$emit('getServerfileList')
          }
        }
      })
    },
    UploadProgress (params) {
      params.currentProgress = this.percentage
      queryUploadProgress(params).then((res) => {
        if (res.data.data.status === 2) {
          // 当status === 2则查询失败
          clearInterval(this.timer)
          this.$message({
            type: 'error',
            message: '同步文件失败,请稍后再试'
          })
          this.status = true
          this.timed = 0
          this.percentage = 0
          this.$emit('getServerfileList')
          return false
        } else if (res.data.data.status === 0) {
          console.log(this.percentage, Number(res.data.data.progress))
          if (this.percentage === Number(res.data.data.progress)) {
            console.log('相等+1')
            this.timed++
          } else {
            console.log('不等')
            this.percentage = Number(res.data.data.progress)
            this.timed = 0
          }
          console.log(this.timed)
          if (this.timed > 10) {
            // progress === 'null'则查询超时
            clearInterval(this.timer)
            this.$message({
              type: 'warning',
              message: '查询进度超时,请稍后再试或进行手动刷新'
            })
            this.status = true
            this.timed = 0
            this.percentage = 0
            this.$emit('getServerfileList')
            return false
          }
        } else {
          console.log('我还没有超时')
          clearInterval(this.timer)
          this.$message({
            type: 'success',
            message: '同步成功'
          })
          this.$emit('getServerfileList')
          this.status = true
          this.timed = 0
          this.percentage = 0
        }
      })
    },
    // 删除
    del (row) {
      const params = {
        productKey: this.productKey,
        deviceName: this.deviceName,
        fileName: row.fileName,
        fileType: row.fileType
      }
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'error'
      }).then(() => {
        deleteFile(params).then((res) => {
          if (res.data.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.times = 0
            this.timed = 0
            this.percentage = 0
            this.$emit('getServerfileList')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 下载
    downLoadFiles (row) {
      const params = {
        productKey: this.productKey,
        deviceName: this.deviceName,
        fileName: row.fileName,
        fileType: row.fileType
      }
      downloadFile(params).then((Res) => {
        // window.open(Res.data.data)
        loadFileByUrl(Res.data.data)
      })
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style lang='less' scoped>
.stop{
      cursor: not-allowed;
      color: #c1c1c1;
    }
</style>
